/**
 * Represents the default flow compact configuration.
 */
export const excludedFlowNames = [
    "craneCycle",
    "disconnectionAlert",
    "collisionDetection",
];

export const defaultFlows = [
    {
        label: "Alerte de déconnexion",
        name: "disconnectionAlert",
        i18n: "workflows.deconnection_alert",
        width: "100%",
        y: 140.0,
        x: 230.0,
        enabled: false,
        options: [
            {
                type: "checkbox",
                label: "Création d'événement",
                i18n: "workflows.create_event",
                width: "1200px",
                default: false,
                name: "eventDisconnect",
            },
            {
                type: "checkbox",
                label: "Envoi d'email",
                i18n: "workflows.send_mail",
                width: "130px",
                name: "sendEmails",
                // groupKey: true,
            },
            {
                type: "select",
                label: "Utilisateurs",
                i18n: "users.title",
                multiple: true,
                default: [],
                options: [],
                name: "users",
                width: "215px",
            },
            {
                type: "textarea",
                label: "Corp du mail",
                i18n: "workflows.mailBody",
                name: "mailBody",
                default: `Bonjour,
                Il semblerait que le capteur {{payload.unit.name}} soit déconnecté. Pensez à vérifier sur https://app.unifield.io/ et à faire la rotation des batteries.
                Bien à vous,
                L'équipe CAD.42`,
                width: "565px",
                height: "80px"
            },
        ]
    },
    {
        label: "Suivi de coups de grue",
        name: "craneCycle",
        i18n: "workflows.crane_cycle",
        y: 225.0,
        x: 230.0,
        enabled: false,
        width: "100%",
        options: [
            {
                type: "checkbox",
                label: "Phases",
                i18n: "Phases",
                width: "110px",
                default: false,
                name: "phase",
            },
            {
                type: "checkbox",
                label: "Coulages",
                i18n: "workflows.concreting",
                width: "110px",
                default: false,
                name: "concreting"
            },
            {
                type: "checkbox",
                label: "Séquences",
                i18n: "workflows.sequences",
                width: "531px",
                default: false,
                name: "sequence"
            },
            {
                type: "checkbox",
                label: "Labelisation",
                i18n: "workflows.label",
                default: false,
                name: "label",
                width: "120px",
            },
            {
                type: "select",
                label: "Objets reconnus",
                i18n: "units.details.tags",
                multiple: true,
                options: [],
                default: [],
                name: "tags",
                widthDiv: "641px",
            },
            {
                type: "number",
                label: "Poids du crochet",
                i18n: "workflows.hookWeight",
                name: "hookWeight",
                value: 150,
                width: "150px"
            },
            {
                type: "number",
                label: "Poids de la benne à vide",
                name: "bucketWeight",
                i18n: "workflows.bucketWeight",
                value: 500,
                width: "190px",
                widthDiv: "601px"
            },
            {
                type: "checkbox",
                label: "Mise à jour du planning",
                i18n: "workflows.planning_update",
                default: false,
                name: "planningUpdate",
                width: "160px",
            },
            {
                type: "select",
                label: "Planning",
                i18n: "planning.details",
                multiple: true,
                options: [],
                default: [],
                name: "plannings",
                width: "240px"
            }
        ]
    },
    {
        label: "Détection de collision",
        name: "collisionDetection",
        i18n: "workflows.collision_detection",
        width: "100%",
        y: 308.0,
        x: 230.0,
        enabled: false,
        options: [
            {
                type: "select",
                label: "Ressources",
                i18n: "planning.resources",
                multiple: true,
                options: [],
                default: [],
                name: "units",
                width: "240px"
            },
            {
                type: "select",
                label: "Zones",
                i18n: "viewer.zones",
                multiple: true,
                options: [],
                default: [],
                name: "zones",
                width: "240px"
            },
            {
                type: "select",
                label: "Margin",
                i18n: "workflows.margin",
                multiple: false,
                options: [],
                default: [],
                name: "margins",
                width: "240px"
            }
        ]
    },
]
